module.exports = __webpack_public_path__ + "a4073522b5532e758e9c96e7d142b18f.svg";